module.exports = __webpack_public_path__ + "img/selected7-min.9cf7d184.png";